export default "__VITE_ASSET__DV5lgKCM__"